import { IconWrapper } from '../runtime';
export default IconWrapper('woa-sharing-one', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "fill": "none",
      "height": props.size,
      "viewBox": "0 0 48 48",
      "width": props.size
    }
  }, [h("linearGradient", {
    "attrs": {
      "id": props.id + '152b5e8c',
      "gradientUnits": "userSpaceOnUse",
      "x1": "24",
      "x2": "24",
      "y1": "0",
      "y2": "48"
    }
  }, [h("stop", {
    "attrs": {
      "offset": "0",
      "stop-color": "#2f8fff"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#0a6cff"
    }
  })]), h("clipPath", {
    "attrs": {
      "id": props.id + '5d3c267d'
    }
  }, [h("path", {
    "attrs": {
      "d": "m0 0h48v48h-48z"
    }
  })]), h("g", {
    "attrs": {
      "clip-path": 'url(#' + props.id + '5d3c267d' + ')'
    }
  }, [h("path", {
    "attrs": {
      "d": "m24 48c-13.254 0-24-10.746-24-24s10.746-24 24-24 24 10.746 24 24-10.746 24-24 24z",
      "fill": 'url(#' + props.id + '152b5e8c' + ')'
    }
  }), h("path", {
    "attrs": {
      "clip-rule": "evenodd",
      "d": "m34.1393 14.0287c-2.5076-1.9167-5.7945-3.0787-9.393-3.0787-7.868 0-14.2463 5.5551-14.2463 12.4077 0 3.6693 1.8288 6.9665 4.7358 9.2382l-1.3751 1.3657.0034.0026-.0034-.0002-3.3607 3.536 6.8606-1.5677c1.7959.7116 3.7914 1.108 5.8931 1.108 7.868 0 14.2463-5.5551 14.2463-12.4077 0-3.6692-1.8288-6.9665-4.7358-9.2381zm-4.054 3.8189c-1.4374-.9503-3.2665-1.5282-5.2876-1.5282-4.7743 0-8.4772 3.225-8.4772 6.9657 0 2.1207 1.1901 4.0756 3.0908 5.3712l-1.6865 1.675c1.5173 1.0129 3.4543 1.6299 5.5962 1.6299 5.0231 0 8.9188-3.393 8.9188-7.3286 0-1.7948-.8103-3.4768-2.1682-4.7756l.0041-.0013c-.5891-.4847-.6307-1.3722-.0894-1.9098l.0894-.0887zm-4.097 1.5195c0 .561-.4579 1.0158-1.0228 1.0158s-1.0228-.4548-1.0228-1.0158c0-.5611.4579-1.0159 1.0228-1.0159s1.0228.4548 1.0228 1.0159z",
      "fill": "#fff",
      "fill-rule": "evenodd"
    }
  })])]);
});